<template>
    <div id="customerService">
        <Headers :headersText='headersText'></Headers>

        <div class="panel">
            <div class="title">客服QQ</div>
            <div class="nums1" data-clipboard-text="304661670" @click="copyKF"><span>304661670</span></div>
            <div class="title">QQ群</div>
            <div class="nums2" data-clipboard-text="656383201" @click="copyQUN"><span>656383201</span></div>
            <div class="text">点击复制QQ/群号</div>
        </div>

        <img src="../../assets/images/img_49.png" alt="" id="bgs">
    </div>
</template>

<script>
    import Headers from '../../components/headers.vue'
    import Clipboard from 'clipboard'
    export default {
        components:{
            Headers
        },
        data() {
            return {
                headersText:'我的客服'
            }
        },
        methods: {
            copyKF:function(){
                var clipboard = new Clipboard('.nums1')
                clipboard.on('success', e => {
                    this.$toast('复制客服QQ成功')
                    // 释放内存
                    clipboard.destroy()
                })
                clipboard.on('error', e => {
                    // 不支持复制
                    this.$toast('该浏览器不支持自动复制')
                    // 释放内存
                    clipboard.destroy()
                })
            },
            copyQUN:function(){
                var clipboard = new Clipboard('.nums2')
                clipboard.on('success', e => {
                    this.$toast('复制QQ群号成功')
                    // 释放内存
                    clipboard.destroy()
                })
                clipboard.on('error', e => {
                    // 不支持复制
                    this.$toast('该浏览器不支持自动复制')
                    // 释放内存
                    clipboard.destroy()
                })
            }
        },
    }
</script>

<style lang="less" scoped>
    #customerService{
        .panel{
            width: 345px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #DEDEDE;
            box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
            margin: 15px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .title{
                font-size: 15px;
                color: #111111;
                font-weight: bold;
                margin: 20px 0 15px;
            }
            .nums1,.nums2{
                width: 215px;
                height: 35px;
                background: #F6F6F6;
                font-size: 18px;
                color: #111111;
                border-radius: 18px;
                font-weight: bold;
                border: 1px dashed #979797;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .text{
                font-size: 13px;
                color: #666666;
                margin: 30px 0 15px;
            }
        }
        #bgs{
            width: 244px;
            height: 165px;
            padding: 53px 65px 20px;
        }
    }
</style>